import React from 'react';
import { getRandomHeadshot, getHeadshotPath } from './utils';
import { useLanguage } from '../context/LanguageContext';

/**
 * Coaching section component featuring one-on-one coaching offerings
 */
const CoachingSection = () => {
  const headshotNumber = getRandomHeadshot();
  const { t } = useLanguage();

  return (
    <section id="coaching" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="font-heading text-3xl md:text-5xl font-bold mb-4 text-center">
          {t('coachingTitle')}
        </h2>
        <p className="font-accent text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto font-light leading-relaxed">
          {t('coachingSubtitle')}
        </p>

        <div className="md:flex md:items-center">
          <div className="md:w-1/2 md:pr-12 mb-10 md:mb-0">
            <h3 className="font-heading text-2xl font-bold mb-4">{t('transformTitle')}</h3>
            <p className="font-accent text-lg text-gray-700 mb-6 leading-relaxed">
              {t('coachingDescription')}
            </p>
            <p className="font-accent text-lg text-gray-700 mb-6 leading-relaxed">
              {t('coachingProcess')}
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-800 p-4 mb-6">
              <h4 className="font-heading font-bold text-lg mb-2">{t('coachingProcess')}</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-green-500 mr-2 mt-1 font-bold">✓</span>
                  <span><strong>{t('assessment')}</strong> - {t('assessmentDesc')}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2 mt-1 font-bold">✓</span>
                  <span><strong>{t('planning')}</strong> - {t('planningDesc')}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2 mt-1 font-bold">✓</span>
                  <span><strong>{t('implementation')}</strong> - {t('implementationDesc')}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2 mt-1 font-bold">✓</span>
                  <span><strong>{t('methods')}</strong> - {t('methodsDesc')}</span>
                </li>
              </ul>
            </div>

            <button className="bg-blue-800 hover:bg-blue-900 text-white font-semibold py-3 px-8 rounded-lg transition shadow-lg tracking-wide">
              {t('applyCoaching')}
            </button>
          </div>
          <div className="md:w-1/2">
            <div className="bg-gray-50 p-8 rounded-lg shadow-xl">
              <img
                src={getHeadshotPath(headshotNumber)}
                alt="Tudor Emanuel Coaching"
                className="w-full h-64 object-cover rounded-lg mb-6"
              />
              <h3 className="font-heading text-2xl font-bold mb-4 text-center">{t('readyTransform')}</h3>
              <p className="font-accent text-gray-600 mb-6 text-center leading-relaxed">
                {t('scheduleSession')}
              </p>
              <button className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-3 px-4 rounded-lg transition tracking-wide">
                {t('bookCall')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoachingSection;